import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { IApplication } from 'src/app/model/iapplication';
import { ModelUtil } from 'src/app/model/model-util';
import { ICaseResponse } from 'src/app/model/service/icase-response';
import { ISubmitApplication } from 'src/app/model/service/isubmit-application';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubmissionService {

  constructor(private httpClient: HttpClient) { }

  public submitApplication(application: IApplication): Observable<ICaseResponse> {
    const input: ISubmitApplication = ModelUtil.toSubmitApplication(application);
    return this.httpClient.post<ISubmitApplication>(environment.baseUrl + '/v1/createApplication', input)
      .pipe(
        concatMap((result: ISubmitApplication) =>
          this.httpClient.post<ICaseResponse>(environment.baseUrl + '/v1/lleg/submitApplication', result),
        ));
  }
}
